import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';
import { AuthModalService } from './services/auth-modal.service';
import { ToastService } from './services/toast.service';
import { ApplicationInsightsService } from './services/application-insights.service';

@Component({
  selector: 'eng-root',
  imports: [RouterOutlet, ToastContainerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private applicationInsightsService = inject(ApplicationInsightsService);

  constructor(
    public authModalService: AuthModalService,
    public toastService: ToastService
  ) {}

  ngOnInit(): void {
    // Application Insights is automatically initialized in the service constructor

    // Check for external login errors in URL parameters
    this.checkForExternalLoginErrors();

    // Expose services globally for MVC bridge
    (window as any).authModalService = this.authModalService;
    (window as any).toastService = this.toastService;
    (window as any).applicationInsightsService = this.applicationInsightsService;
  }

  private checkForExternalLoginErrors(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const success = urlParams.get('success');
    const error = urlParams.get('error');

    // Check if external login failed
    if (success === 'false' && error) {
      // Decode the error message
      const decodedError = decodeURIComponent(error);

      // Display error toast notification
      this.toastService.error('Login Failed', decodedError);

      // Clean up URL parameters after showing the notification
      this.cleanUpUrlParameters();
    }
  }

  private cleanUpUrlParameters(): void {
    // Remove the error parameters from the URL without reloading the page
    const url = new URL(window.location.href);
    url.searchParams.delete('success');
    url.searchParams.delete('error');

    // Update the URL without triggering a page reload
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
  }
}
